import { displayError, localize, getCurrentLanguageId } from "./common";

export default class HttpClient {
    async fetch(input: RequestInfo, init?: RequestInit, onError?: (e: Response|string) => void): Promise<Response> {
        try {
            const response = await fetch(input, init ?? this.getDefaultRequestInit());
            if (!response || !response.ok) {
                if (onError) {
                    onError(response);
                    return response;
                }
                else {
                    displayError(localize('AjaxCallFailGeneralMessage'));
                    throw response.statusText;
                }
            }
            return response;
        }
        catch (e) {
            if (onError) {
                onError(e);
            }
            else {
                displayError(localize('AjaxCallFailGeneralMessage'));
                throw e;
            }
        }
    }

    private getDefaultRequestInit(): RequestInit{
        return {
            headers: {
                'Current-Language-Id': getCurrentLanguageId()
            }
        }
    }
}